import { render, staticRenderFns } from "./field-label.vue?vue&type=template&id=40978cec&scoped=true"
import script from "./field-label.vue?vue&type=script&lang=js"
export * from "./field-label.vue?vue&type=script&lang=js"
import style0 from "./field-label.vue?vue&type=style&index=0&id=40978cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40978cec",
  null
  
)

export default component.exports